import { render, staticRenderFns } from "./ResumenProductos.vue?vue&type=template&id=47ead063"
import script from "./ResumenProductos.vue?vue&type=script&lang=js"
export * from "./ResumenProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports